var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_AdvisoryLayerGroup = function (in_implements, in_extends, options) {
    var implements = [new Class(OCS.Viewer.Interfaces.LayerGroupInfo), new Class(OCS.Viewer.Interfaces.LayerGroupLayer), new Class(OCS.Viewer.Interfaces.LayerGroupSingleLayer)];
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }
    var class_definition = OCS.Viewer.Functions.define_layer_group(implements, OCS.Viewer.Functions.define_base_layer_group(implements, null, options), options);
    return new Class({
        Extends: class_definition,
        class_name: "AdvisoryLayerGroup",
        highlighted: [],
        selected: [],
        has_overlay: true,
        overlay: null,
        debug: false,
        style_manager_class: OCS.Viewer.Functions.define_ol_style_manager([new Class(OCS.Viewer.Interfaces.OlAdvisoryStyle)]),
        compute_changes: true,
        reload_interval_id: null,
        datetime_obj: null,
        options: {

        },
        initialize: function (op) {
            this.addEvent('map_datetime_obj_added', this.on_advisory_map_datetime_obj_added.bind(this));
            this.addEvent('layer_added', this.on_layer_added_advisory.bind(this));
            this.parent(op);
        },
        on_advisory_map_datetime_obj_added: function (datetime_obj) {
            this.datetime_obj = datetime_obj;
            var source_ops = this.get_layer_source_options();
            var source = new OCS.Viewer.Classes[source_ops.metadata.source_type + "Source"](source_ops);
            source.create();
            source.set_dateObj(datetime_obj);
            this.fireEvent('new_layer_source', source, 1);
        },
        on_layer_added_advisory: function (layer) {
            layer.set_dateObj(this.datetime_obj);
            this.fireEvent('activate_layer', layer, 1);

        },

        on_mouse_click: function (mouse_position) {
            var source = this.get_active_layer_source_obj();
            var i, feature, adv_key;
            if (source) {
                var mposition = mouse_position.mouse_position;
                // Determine the number of features at this position
                this.on_mouse_over(mouse_position);
                var features = source.valueFromLonLat(mposition);
                if (features.length) {
                    this.allow_mouse_over = false;
                    this.set_overlay_vis(true);
                    for (i = 0; i < features.length; i++) {
                        feature = features[i];
                        adv_key = feature.get('adv_key');
                        if (source.advisory_features[adv_key] && feature.get('active')) {
                            this.selected.combine([adv_key]);
                            source.advisory_features[adv_key].select(true, mposition);
                        }
                    }
                } else {
                    this.allow_mouse_over = true;
                    this.set_overlay_vis(false);
                }
                var adv_keys = Object.keys(source.advisory_features);
                if (adv_keys.length) {
                    for (i = 0; i < adv_keys.length; i++) {
                        adv_key = adv_keys[i];
                        if (!this.highlighted.contains(adv_key)) {
                            source.advisory_features[adv_key].select(false);
                        }
                    }
                }
            }
        },
        on_mouse_over: function (mouse_position) {
            var feature, adv_key, i;
            var source = this.get_active_layer_source_obj();
            if (source) {
                var mposition = mouse_position.mouse_position;
                this.highlighted = [];
                var features = source.valueFromLonLat(mposition);
                if (features.length && mposition && mposition.length === 2) {
                    for (i = 0; i < features.length; i++) {
                        feature = features[i];
                        adv_key = feature.get('adv_key');
                        if (source.advisory_features[adv_key] && feature.get('active')) {
                            this.highlighted.combine([adv_key]);
                            source.advisory_features[adv_key].highlight(true, mposition);
                        }
                    }

                    this.fireEvent(OCS.Viewer.Config.events.RENDER_HTML, ['advisory_info', this.build_list_html_ops(features), this]);
                    if (this.overlay.getElement() && features.length) {
                        this.overlay.setPosition(mposition);
                    }
                } else {
                    this.fireEvent(OCS.Viewer.Config.events.RENDER_HTML, ['advisory_info', this.build_list_html_ops(features), this]);
                }

                var adv_keys = Object.keys(source.advisory_features);
                if (adv_keys.length) {
                    for (i = 0; i < adv_keys.length; i++) {
                        adv_key = adv_keys[i];
                        if (!this.highlighted.contains(adv_key)) {
                            source.advisory_features[adv_key].highlight(false);
                        }
                    }
                }


            }
        },

        on_overlay_close: function () {
            this.allow_mouse_over = true;
            this.set_overlay_vis();
        },

        get_adv_features: function (source, features) {
            var i, adv_key, feature;
            var feature_objs = [];
            for (i = 0; i < features.length; i++) {
                feature = features[i];
                adv_key = feature.get('adv_key');
                if (source.advisory_features[adv_key]) {
                    feature_objs.push(source.advisory_features[adv_key]);
                }
            }
            return feature_objs;
        },

        set_overlay_vis: function (condition) {
            if (this.overlay) {
                var ovr_element = this.overlay.getElement();
                if (ovr_element) {
                    if (!this.allow_mouse_over) {
                        ovr_element.getElements('.advisory_list_delete').removeClass('hidden');
                    } else {
                        ovr_element.getElements('.advisory_list_delete').addClass('hidden');
                    }
                }
            }
        },

        build_list_html_ops: function (features) {
            var html_ops = {advisories: [], locked: !this.allow_mouse_over, is_hidden: true};
            var i, sig, phenom, dataset_obj, adv_key, feature;
            if (features.length) {
                for (i = 0; i < features.length; i++) {
                    feature = features[i];
                    dataset_obj = OCS.Datasets['edu.ou.ocs.advisories'];
                    adv_key = feature.get('adv_key');
                    if (feature.get('active')) {
                        html_ops.is_hidden = false;
                        phenom = feature.get('phenom');
                        sig = feature.get('significance');


                        var config = OCS.Advisories.Functions.get_adv_config(phenom, sig);
                        if (!config || !config.color) {
                            config = {color: "#00000044"};
                        }
                        html_ops.advisories.push({
                            color: String(config.color).substr(0, 7),
                            adv_id: OCS.Utilities.dots_to_dashes(features[i].get('adv_key')),
                            name: config.name,
                            ending_time: this.datetime_obj.get_display_time_string(features[i].get('ending_time')),
                            warning_url: dataset_obj.get_url({}) + features[i].get('file'),
                        });
                    }
                }
            }
            return html_ops;
        },
        set_html: function (elements) {
            if (this.overlay) {
                elements.getElement('.close_text_list').addEvent('click', this.on_overlay_close.bind(this));
                var el = elements[0];
                this.overlay.setElement(el);
                if (!this.allow_mouse_over) {
                    el.getElements('.advisory_list_delete').removeClass('hidden');
                }

            }
        },
        set_overlay: function (ovrly) {
            this.overlay = ovrly;
        },
        get_layer_short_name: function () {
            if (!this.options.layer_short_name) {
                this.options.layer_short_name = "Advisories";
            }
            return this.options.layer_short_name;
        },
        get_layer_name: function () {
            if (!this.options.layer_name) {
                var dataset_obj = this.get_dataset_obj();
                this.options.layer_name = dataset_obj.getOption('name') + "  Advisories".toLowerCase().capitalize();
            }
            return this.options.layer_name;
        }

    });
};